import { createContext, useContext, useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LangContext = createContext();

export function LangProvider({ children }) {
  const { i18n } = useTranslation();
  const defaultLang = localStorage.getItem("i18nextLng") || "system";
  const [lang, setLang] = useState(defaultLang);

  useEffect(() => {
    console.log("lang = " + lang + " i18n lang=" + i18n.language);
    if (lang == null) {
      return;
    }
    if (lang === "system") {
      const browserLang = navigator.language || navigator.userLanguage;
      i18n.changeLanguage(browserLang);
    } else if (lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
